import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying...");
  const navigate = useNavigate();

  useEffect(() => {
    const orderId = searchParams.get("order_id");
    if (!orderId) return;

    const token = localStorage.getItem("token");

    fetch("/api/payment/verify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ orderId }),
    })
      .then((res) => res.json())
      .then((data) => {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        if (data.status === "SUCCESS") {
          setStatus(" Payment Successful! Your plan is now active.");
          localStorage.setItem("user", JSON.stringify({ ...user, paymentStatus: data.status }));
          setTimeout(() => navigate("/matches"), 3000);
        } else if (data.status === "FAILED") {
          setStatus(" Payment Failed. Please try again.");
        } else {
          setStatus(" Payment is pending. We'll notify you shortly.");
        }
      })
      .catch(() => setStatus("Something went wrong during verification."));
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>{status}</h2>
    </div>
  );
};

export default PaymentSuccess;